<template>
	<div class="content-finish">
		<div style="padding: 0px;" class="mask" v-bind:style="{backgroundColor : color_botones }">
			<img src="https://info.vinapp.co/wp-content/uploads/2021/05/estrellas.png" alt="">
			<div class="check">
				<i class="fas fa-check" v-bind:style="{color : color_botones }"></i>
			</div>
			<h4 class="title">¡Gracias!</h4>
			<h4 class="subtitle">Este es el resumen de tu pedido.</h4>
		</div>
		<div class="data-finish">
			<div class="content-order">
				<h4>Estado: {{ estado }}</h4>
			</div>
			<div class="data-finish-client">
				<div class="both-data-finish">
					<h4>Nombre:</h4>
					<h5>{{ order.name }}</h5>
				</div>
				<div class="both-data-finish">
					<h4>Teléfono:</h4>
					<h5>{{ order.phone }}</h5>
				</div>
			</div>
			<div class="order-finish-client">
				<div class="order-finish-detail">
					<div class="options">
						<h4>Detalle de orden</h4>
						<i class="fas fa-angle-down" @click="show()"></i>	
					</div>
					<div class="products-order">
						<li v-for="item in detail">{{item.name_product}}</li>
					</div>
				</div>
				<div class="finish-order-total">
					<h4>Total:</h4>
					<h5>${{ Intl.NumberFormat("de-DE").format( order.total) }}</h5>
				</div>
			</div>
		</div>
		<div v-if="wa_redirect=='true'" class="container-button" @click="enviarWhatsApp()">
			<div class="send-button">
			  <i class="fab fa-whatsapp what"></i>
			  <label class="send-text">Enviar por WhatsApp</label>
			</div>
		</div>
		<div class="container-button" @click="Volver()">
	      <div class="send-button" v-bind:style="{backgroundColor : color_botones +'!important' }">
			<i class="fas fa-arrow-left"></i>
	        <label class="send-text">Volver a la tienda</label>
	      </div>
    	</div>
		
		
	</div>
</template>

<style scoped>

	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');
	.content-finish{
		width: 100%;
		height: auto;
	}
	.mask{
		width: 100%;
		height: 45vh;
		/*border-bottom-left-radius: 120px;
		border-bottom-right-radius: 120px;*/
	}
	.mask img{
		width: 50%;
		animation: scala .7s ease-in-out;
	}
	.check{
		width: 62px;
		height: 62px;
		border-radius: 50%;
		background: #fff;
		margin: 0 auto;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.check i{
		font-size: 26px;
	}
	.title{
		padding-top: 35px;
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #fff;
		margin-bottom: 4px;
	}
	.subtitle{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #fff;
		padding: 10px;
	}
	.data-finish{
		border-radius: 10px;
		width: 80%;
		height: auto;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 8px 10px 0px rgba(215,215,215,1);
		margin-top:-75px;
	}
	.content-order{
		border-bottom: 1px solid #f2f2f2;
		padding-top: 25px;
		padding-bottom: 10px;
	}
	.content-order h4{
		font-size: 21px;
		font-family: 'Poppins', sans-serif;
		font-weight: 600;
		color: #000;
		margin-bottom: 4px;
	}
	.content-order h5{
		font-size: 17px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
		margin-bottom: 2px;
	}
	.data-finish-client{
		width: 100%;
		height: auto;
		padding: 5px 0px;
		border-bottom: 1px solid #f2f2f2;
	}
	.both-data-finish{
		width: 100%;
		height: auto;
		padding: 5px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.both-data-finish h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}
	.both-data-finish h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}
	.finish-order-total{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.order-finish-detail{
		width: 100%;
		height: auto;
		padding: 15px 10px;
		border-bottom: 1px solid #f2f2f2;
		transition: all .3s ease-in-out;
	}
	.options{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.products-order{
		width: 100%;
		text-align: left;
		padding-left: 15px;
		padding-top: 10px;
		transition: all 3s ease-in-out;
	}
	.products-order li{
		font-size: 15px;
		font-family: 'Poppins', sans-serif;
	}
	.order-finish-detail h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
		margin-bottom: 0;
	}
	.order-finish-detail i{
		margin-right: 5px;
		cursor: pointer;
	}
	.cart-finish-detail{
		width: 100%;
	}
	.height{
		height: 0px !important;
		overflow: hidden;
	}
	.finish-order-total h5{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #000;
	}
	.finish-order-total h4{
		font-size: 16px;
		font-family: 'Poppins', sans-serif;
		font-weight: 500;
		color: #B7B7B7;
	}
	.button-back-to-home button{
		padding: 10px 25px;
		background:transparent;
		font-size: 17px;
		font-weight: 500;
		font-family: 'Poppins', sans-serif;
		border-radius: 5px;
	}
	.button-back-to-home button:focus{
		outline: none !important;
	}
	.button-back-to-home i{
		margin-right: 8px;
	}
	.rotate{
		transform: rotate(180deg);
	}
	@keyframes scala {
		from{
			transform: scale(0);
		}
		to{
			transform: scale(1);
		}
	}
	.container-button{
      width: 95%;
      padding: 10px 0px 10px 0px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
    }
    .send-button{
      width: 100%;
      background: #64B161;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      transition: all 1s;
    }

    .send-button label{
      color: #fff;
      margin-bottom: 0 !important;
      font-weight: 600;
      margin-top: 3px;
    }

    .send-button i:nth-child(1){
		color: #fff;
		margin-right: 6px;
    }
</style>


<script>
	import axios from 'axios';
	export default{
		data(){
			return{
				color_botones: localStorage.getItem('color_licencia'),
				telefono_pedidos: localStorage.getItem('telefono_pedidos'),
				form:{
					id_order:0
				},
				sound: false,
				contador:0,
				total_cart:0,
				order:[],
				detail:[],
				wompi:[],
				company:[],
				status:[],
				estado: "PENDIENTE",
				validarTexto: "Validar mi pago exitoso",
				wa_redirect: localStorage.getItem('wa_redirect'),
			}
		},
		methods:{
			reload(){
				location.reload();
			},
			setupOrder() {
				console.log(this.$route.params.id_order)
				this.form.id_order=this.$route.params.id_order;
				axios.post('https://back.vinapp.co/api/company/getDataOrder',this.form)
					.then(res => {          
          				if(res.data.error == false){
          					this.order=res.data.order;
          					this.detail=res.data.detail;
          					this.company=res.data.company;
          					this.store=res.data.store;
          					this.wompi=res.data.wompi;
          					this.estado = res.data.wompi.estado_actual;
          				}
          			})
          			.catch(err => {
            			console.log(err);      
        			});
			},
			show(){
				if (this.contador == 0) {
					$(".products-order").addClass('height');
					$(".fa-angle-down").removeClass('rotate');
					this.contador++;	
				}else{
					$(".products-order").removeClass('height');
					$(".fa-angle-down").addClass('rotate');
					this.contador = 0;
				}
				
			},
			Volver(){
         location.href = location.origin+'/'+this.$route.params.id
			},
			enviarWhatsApp(){  
		      var self = this;
		      //construimos el mensaje para wapp
		      //se agregan los espacios al nombre de la empresa      
		      this.mensaje = '';
		      let comentario = this.order.commentary;
		      let nombre_comercial = this.company.name;
		      nombre_comercial = nombre_comercial.replace(" ","%20");
		      let nombre = this.order.name;
		      let telefono = this.order.phone;
		      nombre = nombre.replace(" ","%20");     
		      var txtOrder ="Orden "+this.order.id_order+" "; 
		      var value = 0;
		      var reemplazar="";
		      var barrio_u="";
		      if (this.nameOS =='iOS') {
		          this.mensaje += `
		          whatsapp://send?phone=${this.telefono_pedidos}&text=${txtOrder}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
		      }else{
		        this.mensaje += `
		         https://wa.me/${this.telefono_pedidos}?text=${txtOrder}Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20hacer%20un%20pedido`;
		      } 
		      this.mensaje += '%0A%0A';  
		      this.mensaje += `*Dirección:*%20${encodeURIComponent(this.order.address)}`;        
		      this.mensaje += '%0A';//un espacio  
		      this.mensaje += '*Celular:*%20'+this.order.phone;
		      this.mensaje += '%0A%0A';
		      /*this.mensaje += `*Numero de orden:*%20${this.order.id_order}`;
		      this.mensaje += '%0A';*/
		      this.mensaje += '*Detalle de la orden:*';
		      this.mensaje += '%0A';
		      this.detail.forEach((detail)=>{
		        value = 0;
		        this.mensaje += `-%20${detail.quantity}%20x%20${detail.name_product}`;
		        reemplazar = detail.name_product;
		        //reemplazar = reemplazar.replace(" ","%20");
		        reemplazar = encodeURIComponent(reemplazar);
		        this.mensaje += '.%0A%0A';
		      });
		      //definimos la forma de pago.
		      this.mensaje += `*Total%3A*%20${new Intl.NumberFormat("de-DE").format(this.order.total)}`;
		      this.mensaje += '%0A%0A';    
		      this.mensaje += `*Forma de Pago%3A*%20Bancolombia`;
		      let cuenta = "";
		      let banco = "";
		      this.mensaje += '%0A%0A';


		        this.mensaje += `*Pago en Wompi*`; 
		        this.mensaje += '%0A';
		        this.mensaje += `*Id de la transacción%3A*%20${this.wompi.id_transaccion}`;
		        this.mensaje += '%0A%0A';
		        if(this.order.commentary == null){
		        	this.mensaje += `*Comentario%3A*%20`;
		        } else {
		        	this.mensaje += `*Comentario%3A*%20${this.order.commentary}`;
		        }
		      
		      this.mensaje += '%0A%0A';
		      this.mensaje += `Gracias.`; 

		      setTimeout(function() { 
		              $(".button-loading").addClass("send-button");
		              $(".send-button").removeClass("button-loading");
		              $(".send-text").removeClass("hide");
		              $(".what").removeClass("hide");
		              $(".fa-check").addClass("hide");

		      }, 4000); 
		      location.href = this.mensaje;
		    },
		},
		mounted(){
			this.setupOrder();
			this.contador = 0;
		}
	}

</script>